"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const apigw_models_1 = require("@integration/apigw-models");
const class_validator_1 = require("class-validator");
const decorators_1 = require("../decorators");
const SupplyAddressParams_1 = tslib_1.__importDefault(require("./SupplyAddressParams"));
class AddressContractGroupParams extends SupplyAddressParams_1.default {
}
tslib_1.__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.Matches)(/^\d+$/),
    (0, class_validator_1.MinLength)(9),
    (0, class_validator_1.MaxLength)(12),
    (0, decorators_1.ExposeNameCase)(decorators_1.ExposeNameCaseEnum.SNAKE_CASE),
    (0, apigw_models_1.Docs)({ example: '0001022322', description: 'Contract group id' }),
    tslib_1.__metadata("design:type", String)
], AddressContractGroupParams.prototype, "contractGroupId", void 0);
exports.default = AddressContractGroupParams;
